<template>
  <v-breadcrumbs divider="-" :items="breads">
    <v-breadcrumbs-item
      slot="item"
      slot-scope="{ item }"
      @click.native.stop="action(item.id)"
      :key="item.id"
    >{{ item.label }}</v-breadcrumbs-item>
  </v-breadcrumbs>
</template>
<script>
/**
 * Crea un breadcrumb di navigazione sopra il contenuto del menu
 * @module components/common/BreadCrumbMenu
 */
export default {
  name: "breadCrumbMenu",
  /**
   * @prop currentSub {string} - Id dell/oggetto corrente
   * @prop items {array} - Righe del menu
   * @prop action {function} - Azione di click sul bread
   * @prop nopopulate {boolean} - Se vero non popola la proprieta content di ogni item
   */
  props: ["currentSub", "items", "action", "nopopulate"],
  computed: {
    breads() {
      let start = this.items.find(item => item._id == this.currentSub);
      let cParent = start ? start.parent : null;
      let breads = [{ id: null, last: false, label: "BASE" }];
      let inners = [];

      let rowsPopulated;
      if (!this.nopopulate) {
        rowsPopulated = this.items.map(row => ({
          _id: row._id,
          content: new utils.content(
            this.$store.getters[row.contentType].find(
              el => el._id == row.content
            ),
            row.customContent
          ),
          contentType: row.contentType,
          parent: row.parent
        }));
      } else {
        rowsPopulated = this.items;
      }

      while (cParent) {
        let cObj = rowsPopulated.find(item => item._id == cParent);
        inners.push({
          id: cObj._id,
          last: false,
          label: utils.getMainDesc(cObj.content)
        });
        cParent = cObj.parent;
      }

      inners.reverse();

      breads = breads.concat(inners);

      if (this.currentSub != null)
        breads.push({
          id: null,
          last: true,
          label: utils.getMainDesc(
            rowsPopulated.find(item => item._id == this.currentSub).content
          )
        });

      return breads;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/common/BreadCrumbMenu.vue